import {BasicCPCL} from "./basic";
import {Lifecycle} from "@psdk/frame-father";

export class GenericCPCL extends BasicCPCL<GenericCPCL> {
  public constructor(lifecycle: Lifecycle) {
    super(lifecycle);
  }

}
